module.exports = __webpack_public_path__ + "img/fountain-of-youth.582862eb.jpg";